
import { Component, Mixins } from "vue-property-decorator";
import { ItemsStyle, ItemSeparatorKinds } from "../../../../../../documaker/domain/format/objects";
import { IItemsStylePropertyEditable, instanceOfIItemsStylePropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class ItemsStylePropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IItemsStylePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IItemsStylePropertyEditable) => T, defaultValue: T) => T;

  get isItemsStylePropertyEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIItemsStylePropertyEditable(s) && s.itemsStyle().isEditable(), false);
  }

  get itemsStyle(): ItemsStyle {
    return this.readPropertyOrDefault(s => ItemsStyle.from(s.itemsStyle().getValue()), new ItemsStyle(ItemSeparatorKinds.FullWidthPoint));
  }

  set itemsStyle(value: ItemsStyle) {
    this.writePropertyWhenValid(s => s.itemsStyle().setValue(ItemsStyle.to(value)));
  }
}

